import { render, staticRenderFns } from "./AdminCheckingJournalSearch.vue?vue&type=template&id=216e9524&"
import script from "./AdminCheckingJournalSearch.vue?vue&type=script&lang=js&"
export * from "./AdminCheckingJournalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports